import React from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Tokenomics from "./components/Tokenomics";
import Roadmap from "./components/Roadmap";
import Memes from "./components/Memes";
import Community from "./components/Community";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <Hero />
        <About />
        <Tokenomics />
        <Roadmap />
        <Memes />
        <Community />
      </main>
      <Footer />
    </div>
  );
}

export default App;
